export const LOGO_MARK = "https://customer-assets-agu9un31.emergentagent.net/job_vectron-platform/artifacts/57ii2rg1_ONLY%20LOGO.webp";
export const LOGO_FULL = "https://customer-assets-agu9un31.emergentagent.net/job_vectron-platform/artifacts/z6oov76w_vectron-global-logo.png";

export const IMAGES = {
  cnc: "https://images.pexels.com/photos/8956445/pexels-photo-8956445.jpeg",
  sheetMetal: "https://images.unsplash.com/photo-1593106410288-caf65eca7c9d",
  injectionMolding: "https://images.pexels.com/photos/34718928/pexels-photo-34718928.jpeg",
  printing3d: "https://images.pexels.com/photos/20341728/pexels-photo-20341728.jpeg",
  surfaceFinishing: "https://images.unsplash.com/photo-1667892702884-faa077e80d7b",
  roboticsFactory: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b",
  abstractData: "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg",
  engineersBlueprint: "https://images.pexels.com/photos/3861938/pexels-photo-3861938.jpeg",
};
